import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Loader from './components/website/Loader';
import OrderNow from './components/website/OrderNow';
import Dealers from './components/website/Dealers';
import MissionPage from './components/website/about/MissionPage';
import Reports from './components/website/about/Reports';

const HomePage = lazy(() => import('./components/website/HomePage'));
const ProductGrid = lazy(() => import('./components/website/ProductGrid'));
const LoginPage = lazy(() => import('./components/website/LoginPage'));
const OffersPage = lazy(() => import('./components/website/OffersPage'));
const ContactPage = lazy(() => import('./components/website/ContactPage'));
const GalleryPage = lazy(() => import('./components/website/GalleryPage'));

const BoardOfDirectorsPage = lazy(() => import('./components/website/about/BoardOfDirectorsPage'));
const OrgStructurePage = lazy(() => import('./components/website/about/OrganizationStructurePage'));

const ProductsListPage = lazy(() => import('./components/website/products/ProductsListPage'));

const VacanciesPage = lazy(() => import('./components/website/announcements/VacanciesPage'));
const TendersPage = lazy(() => import('./components/website/announcements/TendersPage'));

function AppRoutes() {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about/mission" element={<MissionPage />} />
        <Route path="/about/reports" element={<Reports />} />
        <Route path="/about/board-of-directors" element={<BoardOfDirectorsPage />} />
        <Route path="/about/organization-structure" element={<OrgStructurePage />} />

        <Route path="/products" element={<ProductGrid />} />
        <Route path="/products/products-list" element={<ProductsListPage />} />

        <Route path="/offers" element={<OffersPage />} />
        <Route path="/announcements/vacancies" element={<VacanciesPage />} />
        <Route path="/announcements/tenders" element={<TendersPage />} />

        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/order" element={<OrderNow />} />
        <Route path="/dealer" element={<Dealers />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;